import React from "react";

/**
 * Route-level gate for pages open to OKO staff and superusers, the twin of
 * SuperuserGuard keyed on can_access_school_admin (superuser or staff). A
 * content manager passes /admin/me, so without this gate they would reach the
 * page and its requests would answer 403.
 */
export const StaffGuard = ({ adminUserData, children }) => {
  const isStaff = adminUserData?.can_access_school_admin || false;

  if (!isStaff) {
    return (
      <div
        data-testid="staff-access-denied"
        style={{
          padding: "48px",
          textAlign: "center",
          color: "#666",
        }}
      >
        <h3>Access denied</h3>
        <p>This page is for OKO staff and superusers.</p>
      </div>
    );
  }

  return (
    <>
      {React.Children.map(children, (child) =>
        React.isValidElement(child) && typeof child.type !== "string"
          ? React.cloneElement(child, { adminUserData })
          : child
      )}
    </>
  );
};
